import React from 'react';

export const RedWarningIcon: React.FC = () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="7" cy="7" r="7" fill="#F90000"/>
        <path d="M7.39746 4.90625H6.56934V4.14453H7.39746V4.90625ZM7.35059 10H6.61621V5.63672H7.35059V10Z" fill="white"/>
    </svg>
);
